import { render, staticRenderFns } from "./PendingClient.vue?vue&type=template&id=258a9164"
import script from "./PendingClient.vue?vue&type=script&lang=js"
export * from "./PendingClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports